import React, { PropsWithChildren } from 'react';
import { Theme } from './Theme';

export function BaseLayout({ children }: PropsWithChildren) {
  return <Theme>{children}</Theme>;
}
